export default "__VITE_ASSET__DlAnMYhM__"